
import React, { useState } from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useToast } from "@/hooks/use-toast";

interface TextEditorProps {
  onClose: () => void;
  onAddText: (text: string) => void;
}

const TextEditor: React.FC<TextEditorProps> = ({ onClose, onAddText }) => {
  const [text, setText] = useState("");
  const { toast } = useToast();
  
  const handleAddText = () => {
    if (!text.trim()) {
      toast({
        title: "Error",
        description: "Please enter some text to add to your design.",
        variant: "destructive"
      });
      return;
    }
    
    onAddText(text);
    toast({
      title: "Coming Soon!",
      description: "Text design features will be available soon.",
    });
    onClose();
  };
  
  return (
    <div className="bg-white p-4 w-full max-w-md border rounded-md shadow-md">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-medium">Add Text</h2>
        <Button variant="ghost" size="icon" onClick={onClose}>
          <X className="h-5 w-5" />
        </Button>
      </div>
      
      <div className="space-y-4">
        <Input
          placeholder="Enter text here"
          value={text}
          onChange={(e) => setText(e.target.value)}
          className="w-full"
        />
        
        <Button 
          onClick={handleAddText} 
          className="w-full bg-blue-600 hover:bg-blue-700 text-white"
        >
          Add To Design
        </Button>
      </div>
    </div>
  );
};

export default TextEditor;
